export default "__VITE_ASSET__C3kCPhL6__"